import axios from "../components/shared/axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const getUnit = async (params) => {
  return await axios.get(`${baseURL}/unit`, { params });
};

export const getUnits = async (pageNo, pageSize, param) => {
  let params = {};
  if (param) params = { pageNo, pageSize, ...param };
  else params = { pageNo, pageSize };
  return await axios.get(`${baseURL}/units`, { params });
};


export const addUnit = async (params) => {
  return await axios.post(`${baseURL}/unit`, params);
};

export const updateUnit = async (id, params) => {
  return await axios.put(`${baseURL}/unit/${id}`, params);
};